// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "FundsModule-module--arrow-up-and-down--33895";
export var cardGridLayout = "FundsModule-module--cardGridLayout--c68a8";
export var cardListLayout = "FundsModule-module--cardListLayout--555b5";
export var carouselCard = "FundsModule-module--carouselCard--92eaf";
export var carouselLayout = "FundsModule-module--carouselLayout--1862a";
export var content = "FundsModule-module--content--91668";
export var contentContainer = "FundsModule-module--contentContainer--b4d1a";
export var contentWrapper = "FundsModule-module--contentWrapper--7c892";
export var fundCardWrapper = "FundsModule-module--fundCardWrapper--38638";
export var fundsContainer = "FundsModule-module--fundsContainer--c3979";
export var image = "FundsModule-module--image--47f84";
export var imageContainer = "FundsModule-module--imageContainer--1cf96";
export var overlay = "FundsModule-module--overlay--64c87";
export var text = "FundsModule-module--text--be803";
export var textContainer = "FundsModule-module--textContainer--8c065";
export var title = "FundsModule-module--title--1ca28";
export var videosLayout = "FundsModule-module--videosLayout--d2aed";
export var whiteTextColor = "FundsModule-module--whiteTextColor--dd245";